module.exports = __webpack_public_path__ + "img/27.3f9a8397.jpeg";